module.exports = __webpack_public_path__ + "img/asesoria-legal-2.90c8e416.png";